<template>
    <div class="user-module w-full">
        <div class="flex mt-8 w-full">
            <div class="flex w-4/5">
                <div class="flex flex-col px-6 w-1/3">
                    <div class="form-group">
                        <label for="type">Tip</label>
                        <v-select
                            :tabindex="1"
                            class="form-select"
                            :class="{ _error: validationErrors.type}"
                            id="type"
                            v-model="form.type"
                            :options="typeList"
                            :clearable="false"
                            label="display_name"
                        ></v-select>
                        <span class="error-message" v-if="validationErrors.type" v-text="validationErrors.type[0]"></span>
                    </div>

                    <div v-if="form.type != '' && (form.type.id == 7 || form.type.id == 8 || form.type.id == 5)" class="form-group flex items-center">
                        <div class="box-switch mt-4">
                            <input
                                tabindex="4"
                                type="checkbox"
                                id="status"
                                name="status"
                                v-model="form.status"
                            >
                            <span class="switch-path"></span>
                            <label for="status" v-text="form.status ? 'Aktivan' : 'Neaktivan'"></label>
                        </div>
                        <span class="error-message" v-if="validationErrors.status" v-text="validationErrors.status[0]"></span>
                    </div>

                    <div v-if="showAuthUserFields" class="form-group">
                        <label for="email">E-mail</label>
                        <input
                            tabindex="4"
                            id="email"
                            class="form-control"
                            :class="{ _error: validationErrors.email}"
                            type="text"
                            v-model="form.email"
                        >
                        <span class="error-message" v-if="validationErrors.email" v-text="validationErrors.email[0]"></span>
                    </div>

                    <div v-if="showAuthUserFields" class="form-group flex items-center">
                        <div class="box-switch mt-4">
                            <input
                                tabindex="8"
                                type="checkbox"
                                id="status"
                                name="status"
                                v-model="form.status"
                            >
                            <span class="switch-path"></span>
                            <label for="status" v-text="form.status ? 'Aktivan' : 'Neaktivan'"></label>
                        </div>
                        <span class="error-message" v-if="validationErrors.status" v-text="validationErrors.status[0]"></span>
                    </div>
                </div>
                <div class="flex flex-col px-6 w-1/3">
                    <div v-if="form.type != ''" class="form-group">
                        <label for="name">Ime</label>
                        <input
                            tabindex="2"
                            id="name"
                            class="form-control"
                            :class="{ _error: validationErrors.name}"
                            type="text"
                            v-model="form.name"
                        >
                        <span class="error-message" v-if="validationErrors.name" v-text="validationErrors.name[0]"></span>
                    </div>

                    <div v-if="showAuthUserFields" class="form-group">
                        <label for="password">Lozinka</label>
                        <input
                            tabindex="5"
                            id="password"
                            class="form-control"
                            :class="{ _error: validationErrors.password}"
                            type="password"
                            v-model="form.password"
                        >
                        <span class="error-message" v-if="validationErrors.password" v-text="validationErrors.password[0]"></span>
                    </div>
                </div>
                <div class="flex flex-col px-6 w-1/3">
                    <div v-if="form.type != ''" class="form-group">
                        <label for="last_name">Prezime</label>
                        <input
                            tabindex="3"
                            id="last_name"
                            class="form-control"
                            :class="{ _error: validationErrors.last_name}"
                            type="text"
                            v-model="form.last_name"
                        >
                        <span class="error-message" v-if="validationErrors.last_name" v-text="validationErrors.last_name[0]"></span>
                    </div>

                    <div v-if="showAuthUserFields" class="form-group">
                        <label for="password_confirmation">Ponovite lozinku</label>
                        <input
                            tabindex="6"
                            id="password_confirmation"
                            class="form-control"
                            :class="{ _error: validationErrors.password_confirmation}"
                            type="password"
                            v-model="form.password_confirmation"
                        >
                    </div>
                </div>
            </div>
            <div class="flex justify-start items-end w-1/5">
                <div v-if="form.type != ''" class="flex flex-col">
                    <button
                        class="btn primary"
                        @click="submitForm()"
                        :disabled="procesing"
                    >Spremi</button>
                </div>
            </div>
        </div>
        <div>
            <h2 class="w-full mr-4" v-if="redirectMessage" v-text="redirectMessage"></h2>
        </div>
        <response
            v-if="showResponse"
            :data="responseData"
        ></response>
    </div>
</template>
<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import Response from './Response'

export default {
    components: {
        vSelect,
        Response,
    },

    props: {
        userData: {
            type: Object,
            default: () => ({})
        },
        typeList: {
            type: Array,
            default: () => ([])
        },
        statusList: {
            type: Array,
            default: () => ([])
        },
    },

    data() {
        return {
            form: {
                name: '',
                // user_name: '',
                last_name: '',
                email: '',
                status: true,
                type: '',
            },
            validationErrors: {},
            redirectMessage: '',
            showResponse: false,
            responseData: {},
            procesing: false,
        }
    },

    created() {
        this.showLoader();
        // Set the inputs to values to given user data
        if (this.userData.id) {
            _.forEach(this.form, (item, key) => {
                switch (key) {
                    case 'type':
                        this.form[key] = this.typeList.find( type => type.name === this.userData.roles[0].name)
                        break;
                    case 'status':
                        if (!this.userData.deleted_at) {
                            this.form.status = true
                        } else {
                            this.form.status = false
                        }
                        break;
                    default:
                        if (this.userData[key] == 'null' || !this.userData[key]) {
                            this.form[key] = ''
                        } else {
                            this.form[key] = this.userData[key]
                        }
                        break;
                }
            })
        }
        setTimeout(() => {
            this.hideLoader();
        }, 500);
    },

    computed: {
        showAuthUserFields() {
            return this.form.type != '' && this.form.type.id != 7 && this.form.type.id != 8 && this.form.type.id != 5;
        },
    },

    methods: {
        // Submit the form to create a new user
        submitForm() {
            this.procesing = true

            this.showLoader();

            const lastPage = localStorage.getItem('users_last_page');

            let formData = new FormData();
            let endpoint = '';

            // Append all form items
            _.forEach(this.form, (item, key) => {

                if (key === 'type') {
                    formData.append(key, item.name)
                } else {
                    formData.append(key, item)
                }
            })

            // Conditionaly add method to form submit
            if (this.userData.id) {
                formData.append("_method", 'PATCH');
            }

            if (lastPage) {
                formData.append('page', lastPage);
            }

            // Sets the endpoint with data for store/update depending on create or update
            if (this.userData.id) {
                let data = {
                    user: this.userData.id,
                }

                endpoint = route('users.update', data)
            } else {
                endpoint = route('users.store')
            }

            // Send the formData to user controller store/update function depending on endpoint
            axios.post(endpoint, formData)
                .then((response) => {
                    if (response.status === 200) {
                        this.responseData = response.data.data
                        this.showResponse = true

                        setTimeout(() => {
                            this.hideLoader();

                            const lastPage = localStorage.getItem('users_last_page');
                            localStorage.removeItem('users_last_page');

                            let redirectUrl = route("users.index");
                            if (lastPage) {
                                redirectUrl += `?page=${lastPage}`;
                            }

                            window.location.href = redirectUrl;
                        }, 2000);
                    }
                })
                .catch((error) => {
                    this.procesing = false
                    if (typeof(error.response) !== 'undefined')
                        this.validationErrors = error.response.data.errors

                    console.error(error);
                    this.hideLoader();
                });
        },
    }
}
</script>
